module.exports = __webpack_public_path__ + "img/幸運_四方連續_線稿_black.cd3d616c.png";